import { UseFormRegister, FieldErrors } from 'react-hook-form'

interface FormData {
  registrants: number
  registrationOptionId: number | null
}

interface RegistrantsCountSelectorProps {
  register: UseFormRegister<FormData>
  errors: FieldErrors<FormData>
  isSubmitted: boolean
  maxQuantity?: number
}

export const RegistrantsCountSelector = ({
  register,
  errors,
  isSubmitted,
  maxQuantity = 5,
}: RegistrantsCountSelectorProps) => {
  if (maxQuantity <= 1) {
    return (
      <input
        type="hidden"
        value={1}
        {...register('registrants', { valueAsNumber: true })}
      />
    )
  }

  return (
    <div className="bg-white border-2 border-gray-200 rounded-lg p-6 shadow-sm">
      <label
        htmlFor="registrants"
        className="block text-lg font-semibold text-gray-900 mb-3"
      >
        How many people are you registering?
      </label>
      <p className="text-sm text-gray-600 mb-4">
        You can register up to {maxQuantity} people at once. You'll be able to
        enter each person's details on the next page.
      </p>
      <select
        {...register('registrants', {
          required: 'Please select the number of registrants',
          valueAsNumber: true,
          validate: {
            min: v => v >= 1 || 'You must register at least 1 person',
            max: v =>
              v <= maxQuantity ||
              `You can register up to ${maxQuantity} people`,
          },
        })}
        id="registrants"
        className={`w-full px-4 py-3 text-lg border-2 rounded-lg focus:outline-none focus:ring-2 transition-colors ${
          isSubmitted && errors.registrants
            ? 'border-red-500 focus:ring-red-500 focus:border-red-500'
            : 'border-gray-300 focus:ring-vi-red focus:border-vi-red'
        }`}
      >
        {Array.from({ length: maxQuantity }).map((_, i) => (
          <option key={i + 1} value={i + 1}>
            {i + 1} {i === 0 ? 'person' : 'people'}
          </option>
        ))}
      </select>
      {isSubmitted && errors.registrants && (
        <p className="mt-2 text-sm text-red-600">{errors.registrants.message}</p>
      )}
    </div>
  )
}

